export default "__VITE_ASSET__D6KwEuMt__ 800w";